var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('table',{ref:"tblkelas",staticClass:"table table-hover"},[_vm._m(0),_c('tbody',{on:{"click":_vm.handleClick}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("NAMA KELAS")]),_c('th',[_vm._v("TINDAKAN")])])])
}]

export { render, staticRenderFns }